//Get
export const RF_DATA = {
    RF_DATA_LOAD: "RF_DATA_LOAD",
    RF_DATA_SUCCESS: "RF_DATA_SUCCESS",
    RF_DATA_FAIL: "RF_DATA_FAIL",
};

export const RF_POST_API = "https://0sylzdpaf7.execute-api.us-east-1.amazonaws.com/test/mds_vmo";
